<template>

	<LessonPage v-if="this.$root.currentPage == this.$getConst('LESSON_PAGE')" />
	<EmbeddedPage v-else-if="this.$root.currentPage == this.$getConst('EMBEDDED_PAGE')" />
	<ErrorPage v-else-if="this.$root.currentPage == this.$getConst('ERROR_PAGE')" />
	<Status404Page v-else-if="this.$root.currentPage == this.$getConst('STATUS_404_PAGE')" />
	<StartPage v-else />

</template>

<script>
import StartPage from '@/pages/Start';
import LessonPage from '@/pages/Lesson';
import EmbeddedPage from '@/pages/Embedded';
import ErrorPage from '@/pages/Error';
import Status404Page from '@/pages/404';
import '@/assets/scss/style.scss';

export default {
	name: 'App',

	metaInfo: {
		meta: [
			{ name: 'robots', content: 'noindex' }
		]
	},

	components: {
		StartPage,
		LessonPage,
		EmbeddedPage,
		ErrorPage,
		Status404Page
		// LessonPage: () => import('@/pages/Lesson'),
		// EmbeddedPage: () => import('@/pages/Embedded'),
		// ErrorPage: () => import('@/pages/Error'),
		// Status404Page: () => import('@/pages/404')
	},

	data: () => ({
		//
	}),

	created() {
	}
};
</script>
